import { type FC } from 'react';
import { useTranslations } from 'next-intl';

import { Flex, Icons, Text } from '@shared/ui-kit';

const MerchantsListErrorState: FC = () => {
  const t = useTranslations();

  return (
    <Flex
      data-testid="merchants-list-error-state"
      direction="column"
      rowGap="4"
      alignItems="center"
      pt="20"
    >
      <Icons.Shrug
        w={28}
        h={28}
        fill="gray.500"
        mb={4}
      />
      <Text
        fontSize="2xl"
        fontWeight="700"
      >
        {t('Toast.ErrorMessages.default')}
      </Text>
      <Text fontSize="lg">{t('General.tryFilterOrReload')}</Text>
    </Flex>
  );
};

export default MerchantsListErrorState;
